/**
 * Limiti di una riga di composizione senza dipendenze da class-validator:
 * li usano sia i DTO sia il codice puro (parser dell'elenco incollato,
 * normalizzazione dell'output IA).
 */

/** Percentuale dichiarata: `Decimal(5,2)` in DB, CHECK 0 < x <= 100. */
export const DECLARED_PERCENT_MIN = 0.01;
export const DECLARED_PERCENT_MAX = 100;

/**
 * E-number pattern: "E" + 3-4 digits + optional lowercase letter suffix
 * (E250, E160a, E1442). Shared with create/update Ingredient DTOs, which
 * validate the same shape on `Ingredient.additiveENumber`.
 */
export const E_NUMBER_PATTERN = /^E\d{3,4}[a-z]?$/;

/** Una percentuale stampata e' accettabile se sta in (0, 100] con al massimo due decimali. */
export function isValidDeclaredPercent(value: number): boolean {
  return (
    Number.isFinite(value) &&
    value >= DECLARED_PERCENT_MIN &&
    value <= DECLARED_PERCENT_MAX &&
    Math.abs(Math.round(value * 100) - value * 100) < 1e-9
  );
}
